/**
 * PazienteDetailPagina.jsx — la cartella del paziente dello stile dell'utenza
 * (interruttore dello stile, Alex 14/10/2026).
 *
 * Con lo stile di prima e' PazienteDetail, congelata com'era in 638a8209; con
 * lo stile nuovo «Console» e' PazienteDetailConsole, che ha la testata coi
 * segni, le linguette con i numeri e il riepilogo a riquadri (mockup
 * «Paziente»). Due componenti, due serie di fogli (SchedaPaziente.css e
 * Visite.css sotto .stile-classico; SchedaPazienteConsole.css e
 * VisiteConsole.css sotto .stile-console) e non una condizione dentro uno
 * solo: a interruttore spento il disegno e' quello di prima per costruzione,
 * e quando il vecchio stile si toglie si cancellano i file senza ripulire un
 * componente. Le linguette (anamnesi, visite, foto...) sono componenti
 * condivisi: cambia il foglio, non il codice.
 * Lo stile lo decide il server e arriva con l'utente (navigazione/paginaIniziale).
 *
 * @varianti PazienteDetail.jsx PazienteDetailConsole.jsx
 */
import React from 'react';
import { useAuthStore } from '../../store/useStore';
import { stileNuovo } from '../../navigazione/paginaIniziale';
import PazienteDetail from './PazienteDetail';
import PazienteDetailConsole from './PazienteDetailConsole';

const PazienteDetailPagina = () => {
    const utente = useAuthStore((st) => st.user);
    return stileNuovo(utente) ? <PazienteDetailConsole /> : <PazienteDetail />;
};

export default PazienteDetailPagina;
